<template>
    <div class="input--search header-search__form" :class="isBridge ? 'input--disabled' : ''">
        <v-text-field v-model="searchValue" outlined hide-details placeholder="검색어를 입력하세요" @keydown.enter="search" :disabled="isBridge"/>
        <v-btn icon color="primary" class="transparent" @click="search"><i class="icon icon-search" :disabled="isBridge"></i></v-btn>
    </div>
</template>

<script>
export default {
    props: {
        keyword: { type: String, default: null },
    },
    data: () => ({
        searchValue: null,
    }),
    computed: {
        isBridge() {
            return this.$route.path.split("/").includes("programs");
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        "$route.query.searchValue"() {
            this.init();
        },
    },
    methods: {
        init() {
            this.searchValue = this.$route.query.searchValue || null;
        },
        search() {
            const path = "/search";
            const { searchValue } = this;
            if (this.$route.path != path || this.$route.query.searchValue != searchValue) this.$router.push({ path, query: { searchValue } });
        },
    },
};
</script>

<style scoped>
.input--disabled{
    opacity: 0;    
}
</style>
